import { Button, Divider, Drawer, Form, Input } from "antd";
import { ClearOutlined } from "@ant-design/icons";
import React from "react";
import { colors } from "../../../../../../Utils/temas";

export const FiltrosPortabilidade = ({
  visible,
  onClose,
  onFinish,
  onClear,
}) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    const payload = Object.entries(values).reduce((acc, [key, value]) => {
      if (!value) {
        return acc;
      }

      return { ...acc, [key]: value };
    }, {});

    onFinish(payload);
    onClose();
  };

  const handleClear = () => {
    form.resetFields();
    onClear();
  };

  return (
    <Drawer visible={visible} onClose={onClose}>
      <Form
        form={form}
        onFinish={handleFinish}
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <text style={{ fontWeight: "500" }}>Descrição:</text>
          <Form.Item name="descricao">
            <Input />
          </Form.Item>

          <text style={{ fontWeight: "500" }}>Identificador:</text>
          <Form.Item name="identificador">
            <Input />
          </Form.Item>

          <text style={{ fontWeight: "500" }}>Usuário:</text>
          <Form.Item name="nome_usuario">
            <Input />
          </Form.Item>
        </div>

        <div>
          <Divider />

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              style={{
                background: colors.secondary,
                color: "white",
                fontWeight: "500",
              }}
              htmlType="submit"
            >
              Filtrar
            </Button>

            <Button onClick={handleClear} icon={<ClearOutlined />}>
              Limpar
            </Button>
          </div>
        </div>
      </Form>
    </Drawer>
  );
};
